import type { FC } from 'react';

import { useContent, useSetting } from '@eneco/cms';
import { Price as SparkyPrice } from '@eneco/sparky';
import type { PriceProps } from '@eneco/sparky/types';

import type { PriceContent } from './price-content.types';

/**
 * `Price` block for the CMS-agnostic lane, serving **both** providers. A thin wrapper over Sparky's own
 * `Price`, mirroring the legacy component (`libs/sitecore/components/content/src/Price/Price.tsx`).
 */
const Price: FC = () => {
  const content = useContent<PriceContent>();
  const size = useSetting('size');

  return (
    <SparkyPrice
      discountPrice={content.discountPriceText ?? ''}
      discountPriceAriaText={content.discountPriceAriaText ?? ''}
      originalPrice={content.originalPriceText ?? ''}
      originalPriceAriaText={content.originalPriceAriaText ?? ''}
      text={content.text}
      size={size ? (size as PriceProps['size']) : 'M'}
      suffixText={content.suffixText}
    />
  );
};

export default Price;
